import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { useTranslation } from 'react-i18next'

export interface ErrorContextValue {
  text: string
  show: boolean
  setText: Dispatch<SetStateAction<string>>
  setShow: Dispatch<SetStateAction<boolean>>
}

export const ErrorContext = createContext<ErrorContextValue | undefined>(
  undefined
)

interface ErrorContextProviderProps {
  children?: React.ReactNode
}

const PRODUCT_NOT_FOUND_ERROR_TIMEOUT_IN_MS = 1500

export const ErrorContextProvider: React.FC<ErrorContextProviderProps> = ({
  children,
}) => {
  const { t } = useTranslation()
  const [text, setText] = useState<string>(t('common.product-not-found'))
  const [show, setShow] = useState<boolean>(false)

  return (
    <ErrorContext.Provider
      value={{
        text,
        setText,
        show,
        setShow: (value) => {
          setShow(value)
          if (value) {
            setTimeout(() => {
              setShow(false)
            }, PRODUCT_NOT_FOUND_ERROR_TIMEOUT_IN_MS)
          }
        },
      }}
    >
      {children}
    </ErrorContext.Provider>
  )
}

export const useError = () => {
  const context = useContext(ErrorContext)
  if (context === undefined) {
    throw new Error('useError was used outside of its Provider')
  }
  return context
}
